<template>
<div>
  <div class="flex justify-between">
    <p class="text-brand-gray-900 font-medium text-[14px]">Vaše foto</p>
    <p class="text-brand-gray-500 font-medium text-[14px]">
      Alespoň 300×300 px
    </p>
  </div>
  <label
    for="input-file-photo"
    class="flex items-center justify-center w-full h-24 mt-1 bg-white border rounded-[20px] cursor-pointer group border-brand-gray-500"
    :class="{'border-brand-red ring-4 ring-brand-red ring-opacity-25 bg-red-50': fileTooLarge}"
  >
    <div class="flex items-center justify-center w-full h-full transition-all duration-200 rounded-[20px] group-hover:opacity-80 focus:outline-none group-focus:ring-4 ring-brand-blue ring-opacity-25" v-if="!imagePreview">
      <svg
        class="mr-4 duration-200 transform text-brand-blue group-hover:-translate-y-1"
        :class="{'text-brand-red': fileTooLarge}"
        width="36"
        height="36"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20.88 3.26245C17.1253 3.26245 13.9472 5.50964 12.42 8.68495C11.6072 8.12526 10.665 7.71745 9.6075 7.71745C6.92438 7.71745 4.78406 9.84089 4.635 12.4875C1.95188 13.455 0 15.9581 0 18.9675C0 22.8037 3.11625 25.92 6.9525 25.92H12.96C13.2188 25.9228 13.4606 25.7878 13.5928 25.5628C13.7222 25.3378 13.7222 25.0621 13.5928 24.8371C13.4606 24.6121 13.2188 24.4771 12.96 24.48H6.9525C3.8925 24.48 1.44 22.0246 1.44 18.9675C1.44 16.4221 3.15563 14.279 5.49 13.635C5.80781 13.5421 6.02156 13.244 6.0075 12.915C6.00469 12.8137 6.0075 12.7631 6.0075 12.7575C6.0075 10.7578 7.60781 9.15745 9.6075 9.15745C10.6088 9.15745 11.52 9.55964 12.1725 10.215C12.3441 10.3809 12.5887 10.454 12.8222 10.4034C13.0584 10.3528 13.2525 10.1896 13.3425 9.96745C14.4759 6.90745 17.4178 4.70245 20.88 4.70245C25.3238 4.70245 28.9125 8.29401 28.9125 12.735C28.9125 13.064 28.8872 13.3875 28.845 13.725C28.8197 13.9275 28.8816 14.13 29.0138 14.2846C29.1459 14.4393 29.34 14.5293 29.5425 14.535H29.5875C32.3409 14.535 34.56 16.754 34.56 19.5075C34.56 22.2609 32.3409 24.48 29.5875 24.48H23.04C22.7812 24.4771 22.5394 24.6121 22.4072 24.8371C22.2778 25.0621 22.2778 25.3378 22.4072 25.5628C22.5394 25.7878 22.7812 25.9228 23.04 25.92H29.5875C33.12 25.92 36 23.04 36 19.5075C36 16.2309 33.4856 13.6265 30.3075 13.2525C30.3188 13.0781 30.3525 12.915 30.3525 12.735C30.3525 7.51495 26.1 3.26245 20.88 3.26245ZM18 15.5475L17.4825 16.0425L13.8825 19.6425C13.5956 19.9293 13.5956 20.3906 13.8825 20.6775C14.1694 20.9643 14.6306 20.9643 14.9175 20.6775L17.28 18.315V30.96C17.2772 31.2187 17.4122 31.4606 17.6372 31.5928C17.8622 31.7221 18.1378 31.7221 18.3628 31.5928C18.5878 31.4606 18.7228 31.2187 18.72 30.96V18.315L21.0825 20.6775C21.3694 20.9643 21.8306 20.9643 22.1175 20.6775C22.4044 20.3906 22.4044 19.9293 22.1175 19.6425L18.5175 16.0425L18 15.5475Z"
          fill="currentColor"
        />
      </svg>

      <p class="font-medium text-brand-blue" :class="{'text-brand-red': fileTooLarge}">Nahrajte svůj profilový obrázek</p>
    </div>

    <div class="flex items-center justify-between w-full" v-else>
      <img
        class="object-cover w-16 h-16 ml-4 rounded-[20px] "
        v-if="imagePreview"
        :src="imagePreview"
        alt="Vaše nahraná fotografie"
      />

      <button @click.exact.prevent="onFileRemoved" class="flex items-center mr-8 font-medium text-brand-red">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M8.00012 1.33337C6.83068 1.33337 5.85692 2.20718 5.69348 3.33337H3.41288C3.3845 3.32852 3.35574 3.32612 3.32695 3.32621C3.30206 3.32675 3.27725 3.32914 3.25273 3.33337H2.16679C2.10053 3.33244 2.03475 3.34468 1.97327 3.36938C1.91178 3.39409 1.85582 3.43077 1.80864 3.47729C1.76145 3.52382 1.72399 3.57925 1.69841 3.64038C1.67284 3.70151 1.65967 3.76711 1.65967 3.83337C1.65967 3.89964 1.67284 3.96524 1.69841 4.02637C1.72399 4.0875 1.76145 4.14293 1.80864 4.18945C1.85582 4.23598 1.91178 4.27266 1.97327 4.29736C2.03475 4.32207 2.10053 4.33431 2.16679 4.33337H2.87968L3.71887 13.0098C3.80923 13.9453 4.60405 14.6667 5.54374 14.6667H10.4559C11.3956 14.6667 12.1904 13.9454 12.2807 13.0098L13.1206 4.33337H13.8335C13.8997 4.33431 13.9655 4.32207 14.027 4.29736C14.0885 4.27266 14.1444 4.23598 14.1916 4.18945C14.2388 4.14293 14.2763 4.0875 14.3018 4.02637C14.3274 3.96524 14.3406 3.89964 14.3406 3.83337C14.3406 3.76711 14.3274 3.70151 14.3018 3.64038C14.2763 3.57925 14.2388 3.52382 14.1916 3.47729C14.1444 3.43077 14.0885 3.39409 14.027 3.36938C13.9655 3.34468 13.8997 3.33244 13.8335 3.33337H12.7482C12.6951 3.32477 12.6411 3.32477 12.588 3.33337H10.3068C10.1433 2.20718 9.16956 1.33337 8.00012 1.33337ZM8.00012 2.33337C8.62651 2.33337 9.14038 2.75609 9.28723 3.33337H6.71301C6.85987 2.75609 7.37374 2.33337 8.00012 2.33337ZM3.88359 4.33337H12.116L11.2853 12.9135C11.2436 13.3452 10.8894 13.6667 10.4559 13.6667H5.54374C5.11077 13.6667 4.75596 13.3446 4.71432 12.9135L3.88359 4.33337ZM6.82564 5.99288C6.69315 5.99495 6.56689 6.04952 6.47461 6.14462C6.38232 6.23971 6.33156 6.36754 6.33346 6.50004V11.5C6.33252 11.5663 6.34476 11.6321 6.36947 11.6936C6.39417 11.755 6.43085 11.811 6.47738 11.8582C6.5239 11.9054 6.57933 11.9428 6.64046 11.9684C6.70159 11.994 6.76719 12.0072 6.83346 12.0072C6.89972 12.0072 6.96532 11.994 7.02645 11.9684C7.08758 11.9428 7.14301 11.9054 7.18954 11.8582C7.23606 11.811 7.27274 11.755 7.29745 11.6936C7.32215 11.6321 7.33439 11.5663 7.33346 11.5V6.50004C7.33442 6.43312 7.32193 6.36668 7.29674 6.30468C7.27156 6.24267 7.23418 6.18635 7.18682 6.13905C7.13946 6.09176 7.08309 6.05445 7.02105 6.02934C6.95901 6.00423 6.89256 5.99183 6.82564 5.99288ZM9.15898 5.99288C9.02648 5.99495 8.90023 6.04952 8.80794 6.14462C8.71566 6.23971 8.66489 6.36754 8.66679 6.50004V11.5C8.66585 11.5663 8.67809 11.6321 8.7028 11.6936C8.72751 11.755 8.76419 11.811 8.81071 11.8582C8.85723 11.9054 8.91267 11.9428 8.9738 11.9684C9.03492 11.994 9.10053 12.0072 9.16679 12.0072C9.23305 12.0072 9.29865 11.994 9.35978 11.9684C9.42091 11.9428 9.47635 11.9054 9.52287 11.8582C9.56939 11.811 9.60607 11.755 9.63078 11.6936C9.65549 11.6321 9.66773 11.5663 9.66679 11.5V6.50004C9.66775 6.43312 9.65527 6.36668 9.63008 6.30468C9.60489 6.24267 9.56751 6.18635 9.52015 6.13905C9.4728 6.09176 9.41643 6.05445 9.35439 6.02934C9.29235 6.00423 9.2259 5.99183 9.15898 5.99288Z"
            fill="#EE6770"
          />
        </svg>
        Smazat
      </button>
    </div>
  </label>

  <p class="mt-2 text-brand-red" v-if="fileTooLarge">Vaše fotografie je příliš velká. Max. velikost 2MiB.</p>
  <input
    class="hidden"
    @input="onFileAdded"
    id="input-file-photo"
    type="file"
    accept="image/*"
  />
  </div>
</template>

<script>
export default {

    emits: ['onFileAdded', 'onFileRemoved', 'onImagePreviewLoaded'],

    props: {
      maxFileSize: {
        type: Number,
        default: 2097152
      }
    },

    data() {
        return {
            imagePreview: undefined,
            fileTooLarge: false
        }
    },

    methods: {
        onFileAdded(evt) {
            this.fileTooLarge = false;

            if(evt.target.files[0].size > this.maxFileSize) {
              this.fileTooLarge = true;
              return;
            }

            this.$emit('onFileAdded', evt.target.files[0]);

            if (FileReader && evt.target.files[0]) {
                const fr = new FileReader();
                fr.onload = () => {
                   this.imagePreview = fr.result;
                   this.$emit('onImagePreviewLoaded', fr.result);
                }
                fr.readAsDataURL(evt.target.files[0]);
            }
        },

        onFileRemoved() {

            this.$emit('onFileRemoved');
            this.imagePreview = undefined;
        }
    }
};
</script>

<style>
</style>
